module.exports = __webpack_public_path__ + "static/media/omnichannelp_img.a9ed3a31.jpg";